import axios from 'axios';


const token = localStorage.getItem('loginToken');
export const axiosAPIWithJson = axios.create({
  
  baseURL: process.env.REACT_APP_API,
  headers: {
    'Content-Type': 'application/json',
    ...(token && {Authorization:`Bearer ${token}`})
  }
});


export function axiosPostWithJson(api:string,data:any){
  const token = localStorage.getItem('loginToken');
  const axiosAPIWithJson = axios.create({
    baseURL: process.env.REACT_APP_API,
    headers: {
      'Content-Type': 'application/json',
      ...({Authorization:`Bearer ${token}`})
    }
  });

  const result = axiosAPIWithJson.post(api,data)
   return result
}



export function axiosGet(api:string){
  const token = localStorage.getItem('loginToken');
  const axiosAPIWithJson = axios.create({
    baseURL: process.env.REACT_APP_API,
    headers: {
      'Content-Type': 'application/json',
      ...({Authorization:`Bearer ${token}`})
    }
  });

  const result = axiosAPIWithJson.get(api)
   return result
}

export function axiosPutWithJson(api:string,data:any){
  const token = localStorage.getItem('loginToken');
  const axiosAPIWithJson = axios.create({
    baseURL: process.env.REACT_APP_API,
    headers: {
      'Content-Type': 'application/json',
      ...({Authorization:`Bearer ${token}`})
    }
  });

  const result = axiosAPIWithJson.put(api,data)
   return result
}

export function axiosDeleteWithJson(api:string){
  const token = localStorage.getItem('loginToken');
  const axiosAPIWithJson = axios.create({
    baseURL: process.env.REACT_APP_API,
    headers: {
      'Content-Type': 'application/json',
      ...({Authorization:`Bearer ${token}`})
    }
  });

  const result = axiosAPIWithJson.delete(api)
   return result
}


export function axiosPostWithFormData(api:string,data:FormData){
  const token = localStorage.getItem('loginToken');
  const axiosAPIWithJson = axios.create({
    baseURL: process.env.REACT_APP_API,
    headers: {
      'Content-Type': 'multipart/form-data',
      ...({Authorization:`Bearer ${token}`})
    }
  });

  const result = axiosAPIWithJson.post(api,data)
  return result
}

export function axiosPostWithFormDataInReportServer(api:string,data:FormData){
  const token = localStorage.getItem('loginToken');
  const axiosAPIWithJson = axios.create({
    baseURL: process.env.REACT_APP_REPORT_API,
    headers: {
      'Content-Type': 'multipart/form-data',
      ...({Authorization:`Bearer ${token}`})
    }
  });

  const result = axiosAPIWithJson.post(api,data)
  return result
}


export function axiosPutWithFormData(api:string,data:FormData){
  const token = localStorage.getItem('loginToken');
  const axiosAPIWithJson = axios.create({
    baseURL: process.env.REACT_APP_API,
    headers: {
      'Content-Type': 'multipart/form-data',
      ...({Authorization:`Bearer ${token}`})
    }
  });

  const result = axiosAPIWithJson.put(api,data)
  return result
}